<template>
  <cf-expandable-section>
    <template #title>
      <p class="cf-subtitle cf-subtitle--2 cf-subtitle--heavy">
        Add Shipping Instructions
      </p>
    </template>

    <template #content>
      <cf-text-input
        v-model="internalValue"
        type="text"
        label="Shipping Instructions"
        :placeholder="content.ShippingInstructions.metadata.copy"
        name="shippingInstructions"
      />
    </template>
  </cf-expandable-section>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfExpandableSection from '@/view/components/shared/cf-expandable-section/index.vue';

  import CfTextInput from '@/view/components/shared/cf-text-input/index.vue';


  export default {
    name: 'CfAddShippingInstructions',

    components: {
      CfExpandableSection,
      CfTextInput
    },

    props: {
      modelValue: {
        type: String,
        default: null
      }
    },

    computed: {
      ...mapGetters('content', ['content']),

      internalValue: {
        get() {
          return this.modelValue;
        },

        set(value) {
          this.$emit('update:modelValue', value);
        }
      }
    }
  };
</script>
